/* CommaInput.jsx -- a dollar box shown WITH thousands separators when it is not focused ("11,076.92") and exactly as typed while it
 * is (Batch 1b, 2026-11-03, L3605 -- U6 converted only the billing-terms boxes). It NEVER parses: onValue receives the typed text with
 * its commas removed, so every caller's own parse rule (severanceError's Number(), the new-hire parseFloat, the tax cap's digit filter)
 * sees exactly the text that typing the same number without commas gives. While focused it keeps its own draft, so a caller that
 * stores a NUMBER (the new-hire benefits) does not swallow a typed "80." mid-entry. A value that is not a plain number is shown as is.
 * Plain ASCII (CLAUDE.md 12.5 rule 55). */
import React, { useState } from 'react';

export const stripCommas = t => String(t === undefined || t === null ? '' : t).replace(/,/g, '');

/* "11076.92" -> "11,076.92"; "-750000" -> "-750,000"; "12.5" -> "12.5" (the decimals as written); anything else unchanged */
export function withCommas(v) {
  const s = String(v === undefined || v === null ? '' : v);
  const m = /^(-?)(\d+)(\.\d*)?$/.exec(s.trim());
  if (!m) return s;
  return m[1] + m[2].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (m[3] || '');
}

export default function CommaInput({ value, onValue, onFocus, onBlur, ...rest }) {
  const [draft, setDraft] = useState(null);   // null = not focused
  const raw = value === undefined || value === null ? '' : String(value);
  return <input type="text" inputMode="decimal" {...rest}
    value={draft !== null ? draft : withCommas(raw)}
    onFocus={e => { setDraft(raw); if (onFocus) onFocus(e); }}
    onBlur={e => { setDraft(null); if (onBlur) onBlur(e); }}
    onChange={e => { setDraft(e.target.value); onValue(stripCommas(e.target.value)); }} />;
}
